import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { Observable, filter, forkJoin, takeUntil } from 'rxjs'

import { AuthService } from '@app/modules/auth/auth.service'
import { PlatformSettingsService } from '@core/services/platfrom-settings.service'
import { Router } from '@angular/router'
import { DestroyService } from '@core/services/destroy.service'

import { PlatformSettings } from '@app/shared/models/platform-settings.model'
import { TermOfUse } from '@app/modules/auth/auth-response.model'

@Component({
  selector: 'lin-terms-of-use',
  templateUrl: './terms-of-use.component.html',
  styleUrls: ['./terms-of-use.component.scss'],
  providers: [DestroyService],
  standalone: false,
})
export class TermsOfUseComponent implements OnInit {
  form: FormGroup
  terms: { [key: string]: { link: string; opened: boolean } } = {}
  platformSettings$: Observable<PlatformSettings>

  isSubmitting = false

  constructor(
    private readonly fb: FormBuilder,
    private readonly authService: AuthService,
    private readonly platformSettingsService: PlatformSettingsService,
    private readonly router: Router,
    private readonly destroyService: DestroyService,
  ) {}

  ngOnInit(): void {
    if (this.authService.isLoggedIn && this.authService.termsAcceptedSource.getValue()) {
      void this.router.navigate([this.authService.getCurrentUser().team.type])
    }

    this.createForm()

    this.platformSettings$ = this.platformSettingsService.platformSettings$
    this.platformSettings$.pipe(filter(Boolean), takeUntil(this.destroyService)).subscribe((settings) => {
      this.terms['tos'] = { link: settings.termsOfUseLink, opened: false }
      this.terms['pp'] = { link: settings.privacyPolicyLink, opened: false }
    })
  }

  checkCheckbox(event: Event, type: 'tos' | 'pp'): void {
    this.form.get(type).markAsTouched()
    !this.terms[type]?.opened && event.preventDefault()
  }

  getCheckboxErrorState(type: 'tos' | 'pp'): boolean {
    return this.form.get(type).touched && !this.terms[type]?.opened
  }

  openLink(type: 'tos' | 'pp'): void {
    window.open(this.terms[type]?.link, '_blank')
    this.terms[type].opened = true
  }

  submitForm(): void {
    this.isSubmitting = true
    const requests$: Observable<TermOfUse>[] = []

    Object.entries(this.form.controls).forEach(([key, control]) => {
      control.value && requests$.push(this.authService.acceptTerm(key))
    })

    forkJoin(requests$)
      .pipe(takeUntil(this.destroyService))
      .subscribe(() => {
        this.authService.termsAcceptedSource.next(true)
        void this.router.navigate([this.authService.getCurrentUser().team.type])
        this.isSubmitting = false
      })
  }

  private createForm(): void {
    this.form = this.fb.group({
      tos: [false, Validators.requiredTrue],
      pp: [false, Validators.requiredTrue],
    })
  }
}
